import { getEventPath } from '@/lib/navigation/routes';

const MAX_BADGE_COUNT = 99;

export type NotificationRouteLike = {
  route?: unknown;
  event_id?: unknown;
  eventID?: unknown;
  organization_id?: unknown;
  venue_id?: unknown;
  username?: unknown;
};

export function clampBadgeCount(count: number) {
  return Math.min(MAX_BADGE_COUNT, Math.max(0, count));
}

export function formatBadgeCountLabel(count: number) {
  if (count <= 0) {
    return null;
  }

  if (count > MAX_BADGE_COUNT) {
    return `${MAX_BADGE_COUNT}+`;
  }

  return String(count);
}

export function resolveNotificationRoute(data: NotificationRouteLike) {
  const route = typeof data.route === 'string' ? data.route.trim() : '';
  if (isAllowedNotificationRoute(route)) {
    return route;
  }

  // Older notification payloads sent resource IDs instead of routes; keep those deep links working safely.
  const eventID =
    typeof data.event_id === 'string'
      ? data.event_id
      : typeof data.eventID === 'string'
        ? data.eventID
        : '';
  if (eventID) {
    return getEventPath(eventID);
  }

  const username = typeof data.username === 'string' ? data.username.trim() : '';
  if (username) {
    return `/profiles/${username}`;
  }

  return '/(tabs)/activity';
}

// Notification payloads cross a trust boundary; keep route destinations narrow and internal.
export function isAllowedNotificationRoute(route: string) {
  if (route === '/(tabs)/activity' || route === '/settings-notifications' || route === '/workspaces') {
    return true;
  }

  return (
    /^\/events\/[^/?#]+$/.test(route) ||
    /^\/profiles\/[^/?#]+$/.test(route) ||
    /^\/venues\/[^/?#]+(?:\/approved)?$/.test(route) ||
    /^\/invitations\/[^/?#]+$/.test(route) ||
    /^\/workspaces\/[^/?#]+(?:\/organization)?$/.test(route)
  );
}
